/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FetchResult } from '../models/FetchResult';
import type { HealthCheckResponse } from '../models/HealthCheckResponse';
import type { ImportFromUrlRequest } from '../models/ImportFromUrlRequest';
import type { ImportResult } from '../models/ImportResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ImportService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Product Dl Health
     * Check if the product_dl service is available.
     * @returns HealthCheckResponse Successful Response
     * @throws ApiError
     */
    public productDlHealthApiV1ImportHealthGet(): CancelablePromise<HealthCheckResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/import/health',
        });
    }
    /**
     * Fetch Product Data
     * Fetch product_dl data for an existing item's URL without saving anything.
     * @returns FetchResult Successful Response
     * @throws ApiError
     */
    public fetchProductDataApiV1ImportFetchIdGet({
        id,
    }: {
        id: number,
    }): CancelablePromise<FetchResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/import/fetch/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Import From Url
     * Fetch product info from a URL via product_dl and create a new item.
     * @returns ImportResult Successful Response
     * @throws ApiError
     */
    public importFromUrlApiV1ImportFromUrlPost({
        requestBody,
    }: {
        requestBody: ImportFromUrlRequest,
    }): CancelablePromise<ImportResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/import/from-url',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Import Update From Url
     * Re-fetch an existing item's stored URL and update its metadata. Attaches new images found.
     * @returns ImportResult Successful Response
     * @throws ApiError
     */
    public importUpdateFromUrlApiV1ImportUpdateIdPost({
        id,
        importImages = true,
        importAttachments = true,
    }: {
        id: number,
        importImages?: boolean,
        importAttachments?: boolean,
    }): CancelablePromise<ImportResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/import/update/{id}',
            path: {
                'id': id,
            },
            query: {
                'import_images': importImages,
                'import_attachments': importAttachments,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
